<template>
  <div class="tbltilemini">
    <CardRowSimple
      class="tbltilemini_board"
      style="--crds-card-height: 1.5em; --crds-card-value-size-increase: 0.8"
      :board="board"
    >
    </CardRowSimple>
    <div
      v-show="pot"
      class="tbltilemini_pot text-nowrap"
    >
      {{ numFixedUnit(pot, 'bb') }} BB
    </div>
  </div>
</template>

<script>
import CardRowSimple from '@/components/CardRow/CardRowSimple'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'StudyTableTileMini',
  components: {
    CardRowSimple,
  },
  mixins: [format_mix],
  props: {
    hSpot: Object,
  },
  computed: {
    pot() {
      return this.hSpot?.pot || 0
    },
    board() {
      return this.hSpot?.board
    },
  },
}
</script>
<style lang="scss" scoped>
.tbltilemini {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.5rem 0 0.25rem;
  background: var(--clr-black-1);
  border-radius: 4px;
  gap: 0.5rem;
  &_board {
  }
  &_pot {
    font-weight: 700;
    font-size: 0.875rem;
  }
}
</style>
